import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/pro-solid-svg-icons/faPhoneAlt';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faUserAlt } from '@fortawesome/pro-solid-svg-icons/faUserAlt';

import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { LabeledInfo } from 'ui-components/components/labeled-info';
import { StringHelperService } from '../../services/string-helper-service';

import style from './customer-recipient-widget.module.less';
import { emptyObject } from 'ui-components/default-props/empty';

const messages = defineMessages({
  soldTo: {
    description: 'orderDetails.soldTo',
    defaultMessage: 'Sold To',
    id: '6zGOOT',
  },
  soldToUsername: {
    description: 'orderDetails.soldToUsername',
    defaultMessage: 'Username:',
    id: 'z/H31z',
  },
  emailIconTooltip: {
    description: 'order details email icon tooltip text',
    defaultMessage: 'Email',
    id: 'Q1U1K1',
  },
  usernameIconTooltip: {
    description: 'order details username icon tooltip text',
    defaultMessage: 'Buyer ID',
    id: '3Ngn9X',
  },
});

const NameLine = ({ name = '' }) => {
  if (!name) {
    return null;
  }
  return (
    <div className={style['line-content']} title={name}>
      {name}
    </div>
  );
};
NameLine.propTypes = {
  name: PropTypes.string,
};

const PhoneLine = ({ phone = '' }) => {
  if (!phone) {
    return null;
  }
  return (
    <div className={style.flex}>
      <FontAwesomeIcon className={style.icon} icon={faPhoneAlt} />
      <div className={style['line-content']} title={phone}>
        {phone}
      </div>
    </div>
  );
};
PhoneLine.propTypes = {
  phone: PropTypes.string,
};

const EmailLink = ({ email = '' }) => {
  const intl = useIntl();
  if (!email) {
    return null;
  }
  return (
    <div className={style.flex}>
      <FontAwesomeIcon className={style.icon} icon={faEnvelope} title={intl.formatMessage(messages.emailIconTooltip)} />
      <a className={style['line-content']} href={`mailto:${email}`} title={email}>
        {email}
      </a>
    </div>
  );
};
EmailLink.propTypes = {
  email: PropTypes.string.isRequired,
};

const Username = ({ username = '' }) => {
  const intl = useIntl();

  if (!username) {
    return null;
  }
  return (
    <div className={style.flex}>
      <FontAwesomeIcon className={style.icon} icon={faUserAlt} title={intl.formatMessage(messages.usernameIconTooltip)} />
      <div className={style['line-content']} title={username}>
        {username}
      </div>
    </div>
  );
};
Username.propTypes = {
  username: PropTypes.string,
};

const SoldTo = ({ soldTo = emptyObject }) => {
  const { email, name, phone, username } = soldTo;
  const intl = useIntl();
  const hasEmail = !StringHelperService.isBlank(email);
  const showMdash =
    !hasEmail && StringHelperService.isBlank(name) && StringHelperService.isBlank(username) && StringHelperService.isBlank(phone);
  return (
    <div className={style['sold-to']}>
      <LabeledInfo
        childWrapperClassName={style['labeled-info-content']}
        className={style['labeled-info']}
        label={intl.formatMessage(messages.soldTo)}
        showMdash={showMdash}
      >
        <NameLine name={name} />
        <PhoneLine phone={phone} />
        {hasEmail && <EmailLink email={email} />}
        {!StringHelperService.isBlank(username) && <Username username={username} />}
      </LabeledInfo>
    </div>
  );
};

SoldTo.propTypes = {
  soldTo: PropTypes.shape({
    customerId: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string,
    username: PropTypes.string,
  }),
};

export default SoldTo;
